module.exports = __webpack_public_path__ + "/static/assets/b592c8b4b02de3c7d367ce10efa9d7a6.svg";